import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    modalFrameId: { type: String, default: "onboarding_custom_role_modal" },
    modalUrl: { type: String, default: "" },
    showRank: { type: Boolean, default: false }
  }

  connect() {
    this.initTomSelect()
    this.boundHandleCustomRole = this.handleCustomRoleCreated.bind(this)
    document.addEventListener("custom-role-created", this.boundHandleCustomRole)
  }

  disconnect() {
    document.removeEventListener("custom-role-created", this.boundHandleCustomRole)
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  initTomSelect() {
    const self = this

    this.tomSelect = new TomSelect(this.selectTarget, {
      plugins: ["remove_button"],
      maxOptions: null,
      create: false,
      placeholder: this.element.dataset.placeholder || "Search and select roles...",
      render: {
        option: (data, escape) => {
          if (data.value === "__add_custom__") {
            return `<div class="ts-add-custom" data-custom-action="open-modal"><i class="fas fa-plus mr-2"></i>${escape(data.text)}</div>`
          }
          return `<div>${escape(data.text)}</div>`
        },
        item: (data, escape) => {
          if (data.value === "__add_custom__") return ""
          if (self.showRankValue) {
            // Leading rank badge; number filled in live by updateRanks().
            return `<div class="flex items-center gap-1"><span class="ts-rank inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded bg-[var(--pu-teal)] text-white text-[10px] font-semibold"></span>${escape(data.text)}</div>`
          }
          return `<div>${escape(data.text)}</div>`
        }
      },
      onInitialize: function() {
        // Intercept clicks on the "Add Custom Role" option directly
        this.dropdown_content.addEventListener("mousedown", (e) => {
          const customOption = e.target.closest("[data-custom-action='open-modal']")
          if (customOption) {
            e.preventDefault()
            e.stopPropagation()
            self.openCustomRoleModal()
          }
        })
        self.updateRanks()
      },
      onChange: () => {
        self.updateRanks()
      },
      onItemAdd: (value) => {
        if (value === "__add_custom__") {
          // Remove immediately so it doesn't appear as a selected tag
          this.tomSelect.removeItem("__add_custom__", true)
          this.openCustomRoleModal()
        }
      }
    })
  }

  // Live preference-rank badges (1..N) in selection order. The submit order of
  // medical_role_ids[] = this order, which the server maps to ShiftMedicalRole
  // priority (1 = strongest preference / first filled by the solver).
  updateRanks() {
    if (!this.showRankValue || !this.tomSelect) return
    this.tomSelect.items.forEach((value, index) => {
      const item = this.tomSelect.getItem(value)
      const badge = item && item.querySelector(".ts-rank")
      if (badge) badge.textContent = index + 1
    })
  }

  openCustomRoleModal() {
    // Close the dropdown first
    if (this.tomSelect) {
      this.tomSelect.close()
    }

    const frame = document.getElementById(this.modalFrameIdValue)
    if (frame && this.modalUrlValue) {
      frame.src = this.modalUrlValue
    }
  }

  handleCustomRoleCreated(event) {
    const roleName = event.detail.roleName
    if (!roleName) return

    this.tomSelect.addOption({ value: roleName, text: roleName })
    this.tomSelect.addItem(roleName, true)
  }
}
